import { gql } from '../../../../../hooks'

export const GET_REPORT = gql`
  query GetReport($id: ID!) {
    t4Report(id: $id) {
    }
  }
`
